"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var origin = window.location.protocol + "//" + window.location.hostname;
var _default = origin;
exports.default = _default;
module.exports = exports.default;